<div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <app-notificacoes-perfis *ngIf="mensagens" [notificacaoMensagens]="mensagens" [notificacaoStatus]="statusSucesso"
        (fecharNotificacoes)="mensagens = []">
      </app-notificacoes-perfis>
      </div>
        <div class="col">
            <h2> {{modoVisao ? 'Detalhando ' : 'Editando '}} o perfil: <strong>{{perfil.dscperfil}}</strong></h2>
        </div>
        <div class="col text-end">
          <button class="btn btn-terceary" routerLink="/perfis" >
            <i class="fa fa-undo" aria-hidden="true"></i> Voltar a Lista de Perfis</button>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col">
            <!-- <h4>Qtd. de Usuários no perfil: {{perfil?.dscperfil}} #{{listaUsuariosDoPerfil.length}}</h4> -->
            <table class="table table-striped" id="tabela-usuarios" *ngIf=" listaUsuariosDoPerfil.length > 0">
              <thead>
                <tr>
                  <th scope="col">Usuário</th>
                  <th scope="col">Acesso Ativo?</th>
                  <th scope="col">Login Ativo?</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of listaUsuariosDoPerfil | paginate: { id:'p2', itemsPerPage: 5, currentPage: paginaAtual };">
                  <td>{{p.dsclogin}}</td>
                  <td>{{p.acessoativo ? 'Sim': 'Não'}}</td>
                  <td>{{p.loginativo ? 'Sim': 'Não'}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="2">
                    <pagination-controls id="p2"  nextLabel="" previousLabel="" (pageChange)="paginaAtual = $event"></pagination-controls>
                  </th>
                  <th class="text-end">
                    <button (click)="exportTableToExcel('tabela-usuarios', 'Lista-Usuarios-Perfil')"
                    [disabled]="listaUsuariosDoPerfil.length < 1"
                    class="btn btn-secondary"><i
                      class="fa fa-file-excel-o"></i> Exportar para
                    excel</button>
                  </th>
                </tr>
              </tfoot>
            </table>
        </div>
     
        <div class="col">
            <ul *ngIf="selecoes.length > 2">
              <li style="padding-bottom: 15px;"> Abaixo alguns dos acessos selecionados</li>
              <li *ngFor="let p of selecoes.slice(0,10)" [innerHTML]="formatarCaminhoLongo(p, 'selecionados')" ></li>
            </ul>
        </div>
     
    </div>
    <div class="row" *ngIf=" !modoVisao" >
        <div class="col text-end">
            <button class="btn btn-secondary" [disabled]="selecoes.length < 2" (click)="salvarPerfil()">Salvar
                Alterações no Perfil</button>
                <button class="btn btn-terceary" data-bs-toggle="modal"
                data-bs-target="#desativar-perfil">
                <i class="fa fa-trash" aria-hidden="true"></i> Desativar Perfil</button>
        </div>
    </div>
</div>

<div class="container">
    <h2>Lista de Acessos</h2>
    <div class="row">
        <div class="col input-group">
            <input type="search" name="filtrarDados" class="form-control" placeholder="Ex. cadastros" #filtro aria-describedby="btn-filtro">
            <button class="btn btn-secondary" id="btn-filtro" type="button" (click)="searchObjects(filtro.value)">Filtrar dados...
            </button>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col">
            <app-perfil-unico *ngFor="let item of indiceRemissivoFiltrado"
            [indiceRemissivo]="item"
            [modoVisao]="modoVisao"
            [userGuid]="usuario.guid"
                (indiceSelecionadoEvent)="marcarComoSelecionado($event)"></app-perfil-unico>
            <p *ngIf="indiceRemissivoFiltrado.length < 1">Nenhum perfil com a palavra <strong>{{filtro.value}}</strong>
                foi encontrado!</p>
        </div>
    </div>
</div>



<div class="modal fade" id="desativar-perfil" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="desativar-perfilLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="desativar-perfilLabel">Desativar Perfil</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Deseja realmente desativar o perfil: <strong>{{perfil.dscperfil.toUpperCase()}}</strong>? </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-terceary" data-bs-dismiss="modal" (click)="desativarPerfil()">Confirmar
          Desativamento</button>
      </div>
    </div>
  </div>
</div>


<!--<div class="modal fade" id="add-usuario-perfil" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"-->
<!--  aria-labelledby="add-usuario-perfil-perfilLabel" aria-hidden="true">-->
<!--  <app-criar-usuario *ngIf="perfil != null"-->
<!--  (emmitErros)="tratarRetorno($event)"-->
<!--  [perfil]="perfil">-->
<!--</app-criar-usuario>-->


<!--</div>-->
